<div class="leave-page">
  <div class="container py-3">
  <!-- Header -->
  <div class="page-header d-flex flex-wrap align-items-center justify-content-between gap-3 mb-4">
    <div>
      <h2 class="page-title mb-1">Leave Requests</h2>
      <p class="page-subtitle mb-0">Manage employee leave applications</p>
    </div>
    <button type="button" class="btn btn-primary btn-add" (click)="openCreate(leaveModal)">
      <span class="btn-icon" aria-hidden="true">+</span>
      New Leave Request
    </button>
  </div>

  <!-- Stats -->
  <div class="row g-3 mb-4">
    <div class="col-sm-4">
      <div class="stat-card">
        <span class="stat-label">Total requests</span>
        <span class="stat-value">{{ allItems.length }}</span>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="stat-card">
        <span class="stat-label">Showing</span>
        <span class="stat-value">{{ list_length }}</span>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="stat-card">
        <span class="stat-label">Employees</span>
        <span class="stat-value">{{ employees.length }}</span>
      </div>
    </div>
  </div>

  <!-- Filters -->
  <div class="card filter-card mb-4">
    <div class="card-body py-3">
      <div class="row g-2 align-items-end">
        <div class="col-md-5">
          <label class="form-label small text-muted mb-1" for="search">Search employee</label>
          <input
            id="search"
            type="search"
            class="form-control"
            placeholder="Search by name..."
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchChange()"
          />
        </div>
        <div class="col-md-4">
          <label class="form-label small text-muted mb-1" for="date">Filter by month</label>
          <input
            type="month"
            class="form-control"
            id="date"
            [(ngModel)]="filter_date"
            (change)="filterDate()"
          />
        </div>
        <div class="col-md-3 d-flex gap-2">
          <button type="button" class="btn btn-outline-secondary flex-grow-1" (click)="clearFilter()">
            Reset
          </button>
          <button type="button" class="btn btn-outline-primary flex-grow-1" (click)="loadData()">
            Refresh
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="card table-card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <span>Leave applications</span>
      @if (list_length > 0) {
        <span class="badge rounded-pill bg-light text-dark">{{ list_length }} record(s)</span>
      }
    </div>
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-hover leave-table mb-0">
          <thead>
            <tr>
              <th scope="col" class="col-num">#</th>
              <th scope="col">Employee</th>
              <th scope="col">From</th>
              <th scope="col">To</th>
              <th scope="col" class="text-center">Days</th>
              <th scope="col">Type</th>
              <th scope="col">Notes</th>
              <th scope="col" class="text-end col-actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            @if (list_length === 0) {
              <tr>
                <td colspan="8" class="empty-state">
                  <div class="empty-content">
                    <p class="mb-1 fw-semibold">No leave requests found</p>
                    <p class="text-muted small mb-0">Try adjusting filters or add a new request.</p>
                  </div>
                </td>
              </tr>
            }
            @for (item of paginatedItems; track item.id; let i = $index) {
              <tr>
                <td class="text-muted">{{ (page - 1) * pageSize + i + 1 }}</td>
                <td class="fw-medium">{{ item.employee_name }}</td>
                <td>{{ item.from_date | date: 'dd/MM/yyyy' }}</td>
                <td>{{ item.to_date | date: 'dd/MM/yyyy' }}</td>
                <td class="text-center">
                  <span class="days-badge">{{ item.dayDiff }}</span>
                </td>
                <td>
                  <span class="badge leave-badge {{ getLeaveTypeMeta(item.leave_type).badge }}">
                    {{ getLeaveTypeMeta(item.leave_type).label }}
                  </span>
                </td>
                <td class="notes-cell" [title]="item.notes || ''">
                  {{ item.notes || '—' }}
                </td>
                <td class="text-end">
                  <div class="btn-group btn-group-sm" role="group">
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      title="Edit"
                      (click)="openEdit(leaveModal, item)"
                    >
                      Edit
                    </button>
                    <button
                      [disabled]="!utility.isAdmin()"
                      type="button"
                      class="btn btn-outline-danger"
                      title="Delete"
                      (click)="onDelete(item.id)"
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    @if (list_length > pageSize) {
      <div class="card-footer bg-white border-top-0 pt-0 pb-3">
        <ngb-pagination
          class="mb-0"
          [collectionSize]="list_length"
          [(page)]="page"
          [pageSize]="pageSize"
          [maxSize]="5"
          [rotate]="true"
          [boundaryLinks]="true"
        ></ngb-pagination>
      </div>
    }
  </div>
  </div>
</div>

<!-- Unified leave modal -->
<ng-template #leaveModal let-modal>
  <div class="modal-header border-0 pb-0">
    <div>
      <h4 class="modal-title mb-1">
        {{ modalMode === 'edit' ? 'Edit Leave Request' : 'New Leave Request' }}
      </h4>
      <p class="text-muted small mb-0">Fill in the details below</p>
    </div>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss()"
    ></button>
  </div>
  <div class="modal-body pt-3">
    <div class="row g-3">
      <div class="col-12">
        <label for="employee_id" class="form-label">Employee <span class="text-danger">*</span></label>
        <select class="form-select" [(ngModel)]="form.employee_id" id="employee_id" required>
          <option [ngValue]="null" disabled>Select employee...</option>
          @for (employee of employees; track employee.id) {
            <option [ngValue]="employee.id">{{ employee.name }}</option>
          }
        </select>
      </div>

      <div class="col-md-6">
        <label for="from_date" class="form-label">From <span class="text-danger">*</span></label>
        <input
          type="date"
          class="form-control"
          [(ngModel)]="form.from_date"
          id="from_date"
          required
        />
      </div>
      <div class="col-md-6">
        <label for="to_date" class="form-label">To <span class="text-danger">*</span></label>
        <input
          type="date"
          class="form-control"
          [(ngModel)]="form.to_date"
          id="to_date"
          [min]="form.from_date"
          required
        />
      </div>

      @if (previewDays !== null) {
        <div class="col-12">
          <div
            class="duration-preview"
            [class.duration-preview--invalid]="previewDays <= 0"
          >
            @if (previewDays > 0) {
              <span>Duration: <strong>{{ previewDays }}</strong> day(s)</span>
            } @else {
              <span>End date must be on or after the start date.</span>
            }
          </div>
        </div>
      }

      <div class="col-12">
        <label for="leave_type" class="form-label">Leave type <span class="text-danger">*</span></label>
        <select class="form-select" [(ngModel)]="form.leave_type" id="leave_type" required>
          @for (type of leaveTypes; track type.value) {
            <option [value]="type.value">{{ type.label }}</option>
          }
        </select>
      </div>

      <div class="col-12">
        <label for="notes" class="form-label">Notes</label>
        <textarea
          class="form-control"
          [(ngModel)]="form.notes"
          id="notes"
          rows="3"
          placeholder="Optional reason or comments..."
        ></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer border-0 pt-0">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">Cancel</button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!isFormValid || submitting"
      (click)="saveLeave()"
    >
      @if (submitting) {
        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
      }
      {{ modalMode === 'edit' ? 'Save changes' : 'Submit request' }}
    </button>
  </div>
</ng-template>
